<template>
  <div name="input-typework">
    <div class="col-md-12 typework-btn-group-parent">
      <div>
        <label class="name-panel">{{ labels['HRMS18E']['300'] }}</label>
        <div class="panel-btn clearfix">
          <input type="radio" id="parent-work" value="W" v-model="typework" class="hidden" :disabled="checkTypework"/>
          <label for="parent-work" :class="'typework-color-w' + [checkTypework ? '-not-allow' : ''] + ' typework-btn ' + [ (typework === 'W') ? 'active-w' : '' ]">
            <i :class="'fa ' + [ (typework === 'W') ? 'fa-check-square' : 'fa-square' ]"></i>
            {{labels['HRMS18E']['90']}}
          </label>

          <input type="radio" id="parent-holiday" value="H" v-model="typework" class="hidden" :disabled="checkTypework" />
          <label for="parent-holiday" :class="'typework-color-h' + [checkTypework ? '-not-allow' : ''] + ' typework-btn ' + [ (typework === 'H') ? 'active-h' : '' ]">
            <i :class="'fa ' + [ (typework === 'H') ? 'fa-check-square' : 'fa-square' ]"></i>
            {{labels['HRMS18E']['100']}}
          </label>

          <input type="radio" id="parent-traditional" value="T" v-model="typework" class="hidden" :disabled="checkTraditional" />
          <label for="parent-traditional" :class="'typework-color-t' + [checkTraditional ? '-not-allow' : ''] + ' typework-btn ' + [ (typework === 'T') ? 'active-t' : '' ]">
            <i :class="'fa ' + [ (typework === 'T') ? 'fa-check-square' : 'fa-square' ]"></i>
            {{labels['HRMS18E']['110']}}
          </label>

          <input type="radio" id="parent-shutdown" value="S" v-model="typework" class="hidden" :disabled="checkShutdown" />
          <label for="parent-shutdown" :class="'typework-color-s' + [checkShutdown ? '-not-allow' : ''] + ' typework-btn ' + [ (typework === 'S') ? 'active-s' : '' ]">
            <i :class="'fa ' + [ (typework === 'S') ? 'fa-check-square' : 'fa-square' ]"></i>
            {{labels['HRMS18E']['130']}}
          </label>
        </div>
        <div class="line-typework-group"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'input-typework',
  data () {
    return {
      typework: this.parentCurrentTypework,
      typeworkCreate: ''
    }
  },
  created () {
    this.typeworkCreate = this.typework
  },
  watch: {
    parentCurrentTypework (newVal) {
      this.typework = newVal
    },
    typework (newVal) {
      if (this.typeworkCreate !== '') {
        this.setParentTypeworkToTargetTypework({ typework: newVal, targetTypework: this.parentTargetTypework })
      }
      this.typeworkCreate = newVal
    }
  },
  computed: {
    checkTypework () {
      return (this.parentCurrentTypework === 'L')
    },
    checkTraditional () {
      if (this.parentCurrentTypework === 'T' || this.parentCurrentTypework === 'S' || this.parentCurrentTypework === 'L') {
        return true
      } else if (this.parentCurrentTypework === 'H' || this.parentCurrentTypework === 'W') {
        if (this.traditionalDayLists) {
          return (this.traditionalDayLists.indexOf(this.parentCurrentDay) <= -1)
        } else {
          return true
        }
      }
    },
    checkShutdown () {
      if (this.parentCurrentTypework === 'T' || this.parentCurrentTypework === 'S' || this.parentCurrentTypework === 'L') {
        return true
      } else if (this.parentCurrentTypework === 'H' || this.parentCurrentTypework === 'W') {
        if (this.shutdownDayLists) {
          return (this.shutdownDayLists.indexOf(this.parentCurrentDay) <= -1)
        } else {
          return true
        }
      }
    }
  },
  props: [ 'labels', 'parentCurrentDay', 'searchIndex', 'traditionalDayLists', 'shutdownDayLists', 'parentCurrentTypework', 'parentTargetTypework', 'setParentTypeworkToTargetTypework', 'traditionalDays' ]
}
</script>

<style lang="scss">
.typework-btn-group-parent {
  padding: 20px;
  
  .name-panel {
    font-size: 18px;
    font-weight: 700;
    margin: 0 0 10px 0;
  }

  .panel-btn {
    /* padding: 5px 10px; */

    .typework-color-w {
      color: #9E9E9E;
      cursor: pointer;
    }
    .typework-color-w-not-allow {
      color: #9E9E9E;
      cursor: not-allowed;
    }
    .typework-color-h {
      color: #D32F2F;
      cursor: pointer;
    }
   .typework-color-h-not-allow {
      color: #D32F2F;
      cursor: not-allowed;
    }
    .typework-color-t {
      color: #66BB6A;
      cursor: pointer;
    }
   .typework-color-t-not-allow {
      color: #66BB6A;
      cursor: not-allowed;
    }
    .typework-color-s {
      color: #0277BD;
      cursor: pointer;
    }
   .typework-color-s-not-allow {
      color: #0277BD;
      cursor: not-allowed;
    }

    .typework-btn {
      width: 18%;
      text-align: center;
      padding: 10px;
      margin-bottom: -1px;

      @media (max-width:768px) {
        width: 24.8%;
        height: 90px;
        display: block;
        float: left;
        font-size: 14px;
        padding: 10px 5px;

        i {
          display: block;
        }
      }

      &.active-h {
        border-top: 3px solid #D32F2F;
        border-bottom: 1px solid #FFF;
        border-left : 1px solid #E0E0E0; 
        border-right: 1px solid #E0E0E0;
      }

      &.active-w {
        border-top: 3px solid #9E9E9E;
        border-bottom: 1px solid #FFF;
        border-left : 1px solid #E0E0E0; 
        border-right: 1px solid #E0E0E0;
      }

      &.active-s {
        border-top: 3px solid #0277BD;
        border-bottom: 1px solid #FFF;
        border-left : 1px solid #E0E0E0; 
        border-right: 1px solid #E0E0E0;
      }

      &.active-t {
        border-top: 3px solid #66BB6A;
        border-bottom: 1px solid #FFF;
        border-left : 1px solid #E0E0E0; 
        border-right: 1px solid #E0E0E0;
      }
    }
  }
  .line-typework-group {
      border-top: 1px solid #E0E0E0;
  }
}
</style>


// WEBPACK FOOTER //
// inputParentTypework.vue?b95f503c